import Request from 'src/utils/request'

/**
 * 登录
 * @param {*} data
 */
export function loginApi (data) {
  return Request({
    url: '/user/login',
    method: 'post',
    data,
  })
}

/**
 * 忘记密码 获取验证码
 * @param {String} phoneNumber 手机号
 * @param {String} messageType 类型
 * @param {String} systemDomain 域名
 */
export function getCodeApi (data) {
  return Request({
    url: '/sms/send',
    method: 'post',
    data,
  })
}

/**
 * 忘记密码 前置校验验证码
 * @param {String} code 验证码
 * @param {String} messageType 类型
 * @param {String} phoneNumber 手机号
 */
export function checkPhoneCodeApi (data) {
  return Request({
    url: '/sms/check',
    method: 'post',
    data,
  })
}

/**
 * 忘记密码 修改为新密码
 */
export function setPasswordApi (data) {
  return Request({
    url: '/user/change_password',
    method: 'post',
    data,
  })
}

/**
 * 校验是否登录
 */
export function checkLoginApi () {
  return Request({
    url: '/user/check_login',
  })
}

/**
 * 查询系统信息
 */
export function getSystemInfoApi () {
  return Request({
    url: '/system/info',
    unique: true,
  })
}
